let currentLink = '/';

export default function activeLink(state = currentLink, action) {
  switch (action.type) {
    case 'UPDATE_LINK':
      state = '/' + (action.payload.startsWith('/') ? action.payload.slice(1,) : action.payload);
      return state;
    default:
      return state
  }
}